import type { Feature, FeatureCollection } from '@turf/turf';
import localforage from 'localforage';
import type { Property } from '../core/models/properties';
import type { RegionDTO } from '../state/regions/region.models';

export const DB_NAME = `imagery-${import.meta.env.MODE}`;
export const PROPERTY_STORE_NAME = 'properties';

// Any changes on tables need a upgrade version
const DB_VERSION = 1;

export interface PropertyIDB {
  property?: Property;
  regionTreeResponse: RegionDTO;
  soilData?: FeatureCollection<Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon>>;
}

export class IndexedDBPromiseAPI {
  static readonly initializeIDB = (
    name = DB_NAME,
    version = DB_VERSION,
    store_name = PROPERTY_STORE_NAME
  ) => {
    localforage.config({
      name: name,
      version: version,
      storeName: store_name,
    });
    return localforage.setDriver(localforage.INDEXEDDB);
  };
}
